import cloneDeep from "lodash.clonedeep";
import shortid from "shortid";

function childProducts(products, parent) {
    if (!parent) return []
    return products.filter((p) => p.parent === parent.code);
}

export const preprocess = (originalSalesOrder, context) => {
    const {referenceData: {products, orgConfig}} = context;

    if (!originalSalesOrder) return;

    const salesOrder = cloneDeep(originalSalesOrder);
/*
    const filterGeneratedChildren = (salesOrderItems) => salesOrderItems && salesOrderItems.filter((soi) => {
        return (!soi.product || !soi.product.entityType || soi.product.entityType === 'BASE')
    }) || []
    //filter to remove BC and PO items so that we can re-add them on re-processing.

    const salesOrderItems = filterGeneratedChildren(salesOrder.salesOrderItem)
    salesOrder.salesOrderItem = salesOrderItems;
*/
    //architecturally we always remove children products and re-add them when we pre-process

    const salesOrderItems = salesOrder.salesOrderItem
    
    for (let salesOrderItem of salesOrderItems) {
        const product = salesOrderItem.product || products.find((p) => p.code === salesOrderItem.productId || p.id === salesOrderItem.productId);

        if (product && product.entityType !== 'BASE')
            continue;
        //only process base products..


        const children = childProducts(products, product);
        if (product && children.length) {

            // check to see if there are additional performance obligations
            // that need to be added

            if (salesOrderItem.poProcessed) {
                continue;
            }

            const otherPOProducts =
                children.filter((p) => p.entityType === 'PO');
        
            if (otherPOProducts.length) {
                for (let poProduct of otherPOProducts) {
                    salesOrderItems.push({
                        id: shortid.generate(),
                        externalId: poProduct.code,
                        salesOrderId: originalSalesOrder.id,
                        attributes: poProduct.attributes,
                        productId: poProduct.id,
                        quantity: 1,
                        salePrice: 0.0,
                        listPrice: 0.0,
                        product: poProduct
                    })
                }

                salesOrderItem.poProcessed = true
            }
        }
    }

    return salesOrder;
}
